/** @jsx jsx */
import { jsx } from '@emotion/react'
import { css } from '@emotion/react/macro'
import { OnChangeEventContext } from 'react-crane'

import { BoardGroupFragment } from '../../../../generated/graphql'
import { DataField } from '../../../shared/data'
import { Select } from '../../../shared/input'

const creditsContainerCss = css`
  padding-top: 20px;
`
const creditsCss = css`
  display: inline-block;
  width: 250px;
`
const fieldCss = css`
  padding-top: 16px;
`
const groupsCss = css`
  margin-top: 16px;
  width: 250px;
  margin-left: 0;
`

type PlaceholderFieldsProps = {
  /** Label for credits */
  creditsLabel: string
  /** Minimum number of credits for the placeholder */
  creditsMin?: number | undefined
  /** Maximum number of credits for the placeholder */
  creditsMax?: number | undefined
  /** Description of Plan Item */
  description: string | undefined
  /** Current GroupId of Plan Item */
  groupId: string | null | undefined
  /** Whether the item has been locked by an admin */
  locked: boolean
  /** Event callback input/select in form has changed  */
  onChange: (name: string, value: string | BoardGroupFragment | boolean | number) => void
  /** All Plan Groups for Current Plan */
  planGroups: Array<BoardGroupFragment>
  /** Whether the plan is read-only */
  readOnly?: boolean
  /** Label for term */
  termLabel: string
  /** title of Plan Item */
  title: string
}

const defaultProps: Pick<PlaceholderFieldsProps, 'creditsMin' | 'creditsMax' | 'readOnly'> = {
  creditsMin: undefined,
  creditsMax: undefined,
  readOnly: false
}

const PlaceholderFields = ({
  creditsLabel,
  creditsMax,
  creditsMin,
  description,
  groupId,
  locked,
  onChange,
  planGroups,
  readOnly,
  termLabel,
  title
}: PlaceholderFieldsProps) => {
  const handleGroupChange = (e: OnChangeEventContext) => {
    const group = e.value as BoardGroupFragment
    onChange(e.name, group)
  }
  const descr = description || 'none'

  return (
    <div>
      <div>
        <DataField label="Placeholder Title">{title}</DataField>
        <Select
          id={termLabel.toLowerCase()}
          css={groupsCss}
          disabled={locked || readOnly}
          label={termLabel}
          labelKey="title"
          name="group"
          onChange={handleGroupChange}
          options={planGroups}
          value={groupId}
          valueKey="id"
        />
        <div css={creditsContainerCss}>
          <DataField css={creditsCss} label={`Minimum ${creditsLabel}`}>
            {creditsMin !== undefined && creditsMin >= 0 ? creditsMin : 'none'}
          </DataField>
          <DataField css={creditsCss} label={`Maximum ${creditsLabel}`}>
            {creditsMax !== undefined && creditsMax >= 0 ? creditsMax : 'none'}
          </DataField>
        </div>
      </div>
      <DataField css={fieldCss} label="Description">
        {descr}
      </DataField>
    </div>
  )
}

PlaceholderFields.defaultProps = defaultProps

export default PlaceholderFields
